import {Action} from '@ngrx/store';
import {QuestionAnswer} from '../../models/question-answer';
import {USER_SELECTION_STATUS} from "../state";
import {Node} from '../../models';

export enum UserClicksElementsActionTypes {
  PROCESS_USER_SELECTED_ELEMENT = '[Bpmn Process] Process user selected element',
  PROCESS_USER_SELECTED_PATH = '[Bpmn Process] User select forward path',
  SET_ANSWER = '[Bpmn Process] Set answer',
  RESUME_EXECUTION = '[Bpmn Process] Resume execution',
  USER_CLICKED_EXECUTED_NODE = '[Bpmn Process] Uer clicked executed node',
  USER_CHANGED_PATH = '[Bpmn Process] User selected a different path',
  UPDATE_IS_NAVIGATION_ENABLED = '[Bpmn Process] Update Is Navigation Enabled',
  UPDATE_LATEST_SELECTED_NODE_ID = '[Bpmn Process] Update latest selected node id',
  UPDATE_USER_SELECTION_STATUS = '[Bpmn Process] Update User selection status'
}

export class ProcessUserSelectedElementAction implements Action {
  readonly type = UserClicksElementsActionTypes.PROCESS_USER_SELECTED_ELEMENT;
  constructor(public payload: { name: string, id: string}) { }
}

export class ProcessUserSelectedPathAction implements Action {
  readonly type = UserClicksElementsActionTypes.PROCESS_USER_SELECTED_PATH;
  constructor(public payload: { pathFromCommonAncestorToSelected: Node[] }) { }
}

export class SetAnswer implements Action {
  readonly type = UserClicksElementsActionTypes.SET_ANSWER;
  constructor(public payload: { selectedActivityId: string}) { }
}

export class ResumeExecution implements Action {
  readonly type = UserClicksElementsActionTypes.RESUME_EXECUTION;
  constructor(public payload: { id: string, questionsAndAnswers: QuestionAnswer[], userSelectedElement?: string}) { }
}

export class UserClickedExecutedNodeAction implements Action {
  readonly type = UserClicksElementsActionTypes.USER_CLICKED_EXECUTED_NODE;
  constructor(public payload: { id: string}) { }
}

export class UserChangedPathAction implements Action {
  readonly type = UserClicksElementsActionTypes.USER_CHANGED_PATH;
  constructor(public payload: { pathFromCommonAncestorToSelected: Node[] }) { }
}

export class IsNavigationEnabledAction implements Action {
  readonly type = UserClicksElementsActionTypes.UPDATE_IS_NAVIGATION_ENABLED;
  constructor(public payload: { enable: boolean}) { }
}

export class UpdateLatestSelectedNodeIdAction implements Action {
  readonly type = UserClicksElementsActionTypes.UPDATE_LATEST_SELECTED_NODE_ID;
  constructor(public payload: { id: string}) { }
}

export class UpdateUserSelectionStatusAction implements Action {
  readonly type = UserClicksElementsActionTypes.UPDATE_USER_SELECTION_STATUS;
  constructor(public payload: {status: USER_SELECTION_STATUS}) {}
}


export type UserClicksElementsActions =
    ProcessUserSelectedElementAction
  | ProcessUserSelectedPathAction
  | SetAnswer
  | ResumeExecution
  | UserClickedExecutedNodeAction
  | UserChangedPathAction
  | IsNavigationEnabledAction
  | UpdateLatestSelectedNodeIdAction
  | UpdateUserSelectionStatusAction;
